import { useState } from 'react'
import { Launch } from '@mui/icons-material'
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, timelineItemClasses, TimelineSeparator } from '@mui/lab'
import { DialogContent, Grid, IconButton, Typography } from '@mui/material'
import htmlParse from 'html-react-parser'
import sanitizeHtml from 'sanitize-html'

import DialogWithTitle from '../../../../components/dialog-with-title'
import { getFormattedDateTime } from '../../../../utils/helpers'

import useStyles from './index.styles'

const DetailsTimeline = ({
  timelines,
  participantAgreementText,
}: {
  timelines: {
    dotSuccess: boolean
    title: string
    updatedAt: string | undefined
    updatedBy: string | undefined
    isPartipantAgreement?: boolean
  }[]
  participantAgreementText: string | undefined
}) => {
  const classes = useStyles
  const [pdfModal, setPdfModal] = useState<boolean>(false)

  const cleanParticipantAgreementText = sanitizeHtml(participantAgreementText ?? '')

  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {timelines.map(({ updatedAt, updatedBy, title, isPartipantAgreement }, index) => (
        <TimelineItem key={index}>
          <TimelineSeparator>
            <TimelineDot sx={updatedAt ? classes.timelineDotSuccess : undefined} />
            {index < timelines.length - 1 && <TimelineConnector sx={classes.timelineConnector} />}
          </TimelineSeparator>
          <TimelineContent>
            <Grid container={true} sx={{ flexDirection: 'column', marginTop: -1 }}>
              <div>
                <Typography variant="overline">{title}</Typography>
                {isPartipantAgreement && (
                  <>
                    <IconButton color="primary" onClick={() => setPdfModal(true)} aria-label="View Participant Agreement">
                      <Launch fontSize="small" />
                    </IconButton>
                    <DialogWithTitle title="Participant Agreement" open={pdfModal} setOpen={setPdfModal}>
                      <DialogContent sx={classes.paDialogContent}>{htmlParse(cleanParticipantAgreementText)}</DialogContent>
                    </DialogWithTitle>
                  </>
                )}
              </div>
              <Typography variant="body2">
                {updatedAt ? `${isPartipantAgreement ? 'Signed ' : ''}${getFormattedDateTime(updatedAt)}${updatedBy ? ` by ${updatedBy}` : ''}` : 'N/A'}
              </Typography>
            </Grid>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  )
}

export default DetailsTimeline
